export const slider = () => {
  let slider = new Swiper(".slider__swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 4000,
    },

    pagination: {
      el: ".slider__pagination",
      type: 'bullets',
      clickable: true
    }
  });
}